import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { GridRow, GridColumn, Button, Img } from "arv-reactcomponents";
import { ToCurrency } from "../../../../utils";
import { MYACCOUNTPAGE } from "npmlinks-constants";

const {
  LOYALTY: { MORE_INFO, LOYALTY_TIER, POINTS, VALUE },
} = MYACCOUNTPAGE;

class LoyaltyCard extends PureComponent {
  render() {
    const {
      data: { brand, logoURL, loyaltyTier, totalPoints, loyaltyValue },
      openMoreInfoModal,
    } = this.props;
    return (
      <GridColumn className="nwc-grid-col-sm-4 nw-loyaltycard-col">
        <div className="nw-loyaltycard-datadisplay">
          <GridRow className="nw-loyaltycard-datadisplayrow">
            <GridColumn>
              <Img
                className="nw-loyaltycard-brandlogo"
                src={logoURL}
                alt="logo"
              />
              <Button
                className="nwc-btn-primary-txt nw-loyaltycard-moreinfobtn"
                onClick={() => {
                  openMoreInfoModal(brand);
                }}
              >
                {MORE_INFO}
              </Button>
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn className="nwc-grid-col-xs-4 nw-loyaltycard-tierpoints">
              <div className="nw-loyaltycard-subheading">{LOYALTY_TIER}</div>
              <div className="nw-loyaltycard-subtext">{loyaltyTier}</div>
            </GridColumn>
            <GridColumn className="nwc-grid-col-xs-4 nw-loyaltycard-tierpoints">
              <div className="nw-loyaltycard-subheading">{POINTS}</div>
              <div className="nw-loyaltycard-subtext">{totalPoints}</div>
            </GridColumn>
            <GridColumn className="nwc-grid-col-xs-4 nw-loyaltycard-values">
              <div className="nw-loyaltycard-subheading">{VALUE}</div>
              <div className="nw-loyaltycard-subtext">
                {ToCurrency(loyaltyValue)}
              </div>
            </GridColumn>
          </GridRow>
        </div>
      </GridColumn>
    );
  }
}

LoyaltyCard.propTypes = {
  data: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    logoURL: PropTypes.string.isRequired,
    loyaltyTier: PropTypes.string.isRequired,
    totalPoints: PropTypes.number.isRequired,
    loyaltyValue: PropTypes.number.isRequired,
    borderColor: PropTypes.string,
  }).isRequired,
  openMoreInfoModal: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: LoyaltyCard,
  component: LoyaltyCard,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/MyAccountLoyalty/LoyaltyCard/index.js